var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KvTable',{style:(_vm.defaultHeight !== undefined && {height:_vm.defaultHeight}),attrs:{"items":_vm.noteProps}})
}
var staticRenderFns = []

export { render, staticRenderFns }